module.exports = __webpack_public_path__ + "static/spin-logo.08a6939e.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/spin-logo.png
// module id = 542
// module chunks = 1